import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

const echo = new Echo({
    broadcaster: 'pusher',
    key: 'a8f8686390dad6ea9b09',
    cluster: 'mt1',
    forceTLS: true,
    encrypted: true
});

export default echo;
